import {APP_NAME} from '@/config';
import {Credentials} from '@/domain/commonTypes';

const localStorageRepository = {
  getCredentials: (): Credentials => {
    const accessToken = localStorage.getItem(`${APP_NAME}.accessToken`);
    const refreshToken = localStorage.getItem(`${APP_NAME}.refreshToken`);

    return {
      access: accessToken || undefined,
      refresh: refreshToken || undefined
    };
  },
  setCredentials: (credentials: Credentials) => {
    const {access, refresh} = credentials;
    if (access) localStorage.setItem(`${APP_NAME}.accessToken`, access);
    if (refresh) localStorage.setItem(`${APP_NAME}.refreshToken`, refresh);
  },
  removeCredentials: () => {
    localStorage.removeItem(`${APP_NAME}.accessToken`);
    localStorage.removeItem(`${APP_NAME}.refreshToken`);
  }
};

export default localStorageRepository;